import styled from "styled-components";

export const Heading = styled.div`
  text-align: center;
  color: #000;
  font-family: Poppins;
  font-size: 1.125em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 1.75em;
`;
export const Image = styled.div`
  width: 4.5em;
  height: 4.5em;
  margin: 0 auto;
  margin-bottom: 1.7em;
  background: #d9d9d9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  img{
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
export const Upload = styled.div`
  color: #666;
  font-family: Poppins;
  font-size: 1em;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  margin-bottom: 1em;
  text-align: center;
  cursor: pointer;
`;
export const Label = styled.p`
  color: #c8c8c8;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0.9em;
  padding-top: 0.5em;
  border-top: 1px solid#F4F4F4;
  margin-top: 1.5em;
`;
export const Input = styled.input`
  width: 19.5em;
  height: 2.5em;
  margin-bottom: 0.9em;
  border-radius: 0.5em;
  border: 1px solid #8e8e8e;
  background: #fff;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0.5em 0.94em;
  ::placeholder {
    color: #c8c8c8;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
